import { render, staticRenderFns } from "./empty-pages.vue?vue&type=template&id=ab94221a"
import script from "./empty-pages.vue?vue&type=script&lang=js"
export * from "./empty-pages.vue?vue&type=script&lang=js"
import style0 from "./empty-pages.vue?vue&type=style&index=0&id=ab94221a&prod&lang=scss&spcoded=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports